import { render, staticRenderFns } from "./EventCompanyDialog.vue?vue&type=template&id=2047d296&scoped=true"
import script from "./EventCompanyDialog.vue?vue&type=script&lang=ts"
export * from "./EventCompanyDialog.vue?vue&type=script&lang=ts"
import style0 from "./EventCompanyDialog.vue?vue&type=style&index=0&id=2047d296&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2047d296",
  null
  
)

export default component.exports